"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.retry = exports.plainStrToJson = exports.checkUserCreatedMarketo = exports.graphQL = exports.platformHelpers = exports.companyHelpers = exports.sourceToUrlMap = exports.companyConstants = void 0;
var uuid_1 = require("uuid");
var get_1 = __importDefault(require("lodash/get"));
// @ts-ignore
var json_stringify_safe_1 = __importDefault(require("json-stringify-safe"));
var lodash_1 = require("lodash");
// Constants - useful outside of CompanyCore
exports.companyConstants = {
    // Platform events emited or handled
    platformEvents: {
        tileNextAction: 'tileNextAction',
        tileNeedsData: 'tileNeedsData',
        tilesRefresh: 'tilesRefresh',
        closeModal: 'closeModal',
        visibilityNeedsData: 'visibilityNeedsData',
        navEvent: 'navEvent',
        hideTile: 'hideTile',
        hideGroupFromFilter: 'hideGroupFromFilter',
        hideGroupFromTile: 'hideGroupFromTile',
        showAllTiles: 'showAllTiles',
        applyFilterSettings: 'applyFilterSettings',
        openPaywall: 'openPaywall',
        confirmPurchase: 'confirmPurchase',
        selectProduct: 'selectProduct',
        paymentSucceeded: 'paymentSucceeded',
        paymentFailed: 'paymentFailed',
        cancelPurchase: 'cancelPurchase',
        selectTier: 'selectTier',
        dataCollectorComplete: 'dataCollectorComplete',
        dataCollectorDismissed: 'dataCollectorDismissed',
        dataCollectorInitiated: 'dataCollectorInitiated'
    },
    // Action types available to tiles
    tileActions: {
        activate: 'activate',
        deactivate: 'deactivate',
        transitionState: 'transitionState',
        transitionStateV2: 'transitionStateV2',
        navigate: 'navigate',
        navigateSSO: 'navigateSSO',
        navigatePurchase: 'navigatePurchase',
        navigateMIOP: 'navigateMIOP',
        navEvent: 'navEvent',
        scheduleCalendly: 'scheduleCalendly',
        remoteActivate: 'remoteActivate',
        publishFetch: 'tilePublish',
        updateByopTile: 'updateByopTile',
        tileUpdated: 'tileUpdated',
        skynetSSO: 'skynetSSO',
        checkVerification: 'checkVerification',
        paymentFailed: 'paymentFailed'
    },
    actionParams: {
        emailVerificationRequired: 'emailVerificationRequired'
    },
    dataCollectorForms: {
        profile: 'profile',
        domain: 'domain',
        email: 'email',
        business: 'business',
        first: 'first',
        calendly: 'calendly'
    },
    d3: {
        defaultColors: {
            pieChart: ['#4c6372', '#70828e', '#E0E5E7'],
            circleProgressChart: ['#70828e', '#cad4da']
        },
        defaultData: {
            pieChart: [
                { text: 'Correct', value: 33, key: 0 },
                { text: 'Incorrect', value: 33, key: 1 },
                { text: 'Missing', value: 33, key: 2 },
            ],
            circleProgressChart: [
                { text: 'complete', value: 0, key: 0 },
                { text: 'incomplete', value: 100, key: 1 },
            ]
        }
    },
    hosts: {
        account: process.env.REACT_APP_ACCOUNT_HOST,
        dashboard: process.env.REACT_APP_DASHBOARD_HOST
    }
};
// Source url redirect
// TODO: The below mapping of source to URL is temp and
// should go to Database table source, sourceConfig or sourceURI
exports.sourceToUrlMap = {
    ipayment: 'paysafe',
    priority2: 'merchantprotectionplus',
    priority3: 'bizdash'
};
// General Helper functions - useful outside of CompanyCore
exports.companyHelpers = {
    sortDescending: function (d1, d2) {
        return d1.value - d2.value;
    },
    isEmpty: function (value) {
        if (value === undefined || value === null || value === false) {
            return true;
        }
        if (value.trim() === '') {
            return true;
        }
        return false;
    },
    getQueryStringParams: function (queryString) {
        var fromPairs = function (pairs) {
            return pairs.reduce(function (result, pair) {
                var _a;
                return (__assign(__assign({}, result), (_a = {}, _a[pair[0]] = pair[1], _a)));
            }, {});
        };
        var queries = queryString.substr(1).split('&');
        var queryPairs = queries.map(function (query) { return query.split('='); });
        return fromPairs(queryPairs);
    },
    getNestedObj: function (nestedObj, pathArr) {
        return pathArr.reduce(function (obj, key) {
            return obj && obj[key] !== 'undefined' && obj[key] !== null && obj[key] !== false
                ? obj[key]
                : undefined;
        }, nestedObj);
    },
    convertLocationStateToURLParams: function (state) {
        var newSearch = '';
        for (var _i = 0, _a = Object.entries(state); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], value = _b[1];
            newSearch = "".concat(newSearch).concat(
            // @ts-ignore
            value ? "".concat(newSearch.length ? '&' : '?').concat(key, "=").concat(encodeURIComponent(value)) : '');
        }
        return newSearch;
    },
    getTimezone: function (utc) {
        return new Date(utc).toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    },
    validateData: function (reqData, objGraph) {
        var missingData = reqData.filter(function (item) {
            var itemParts = item.trim().split('.');
            return exports.companyHelpers.getNestedObj(objGraph, itemParts) === undefined;
        });
        return missingData;
    },
    validateEmail: function (email) {
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            return true;
        }
        return false;
    },
    validateFQDN: function (fqdn) {
        if (/(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{0,62}[a-zA-Z0-9]\.)+[a-zA-Z]{2,63}$)/.test(fqdn)) {
            return true;
        }
        return false;
    },
    validateHostname: function (fqdn) {
        if (!/^[a-zA-Z0-9-]*$/.test(fqdn)) {
            return true;
        }
        return false;
    },
    validateZipCode: function (zipCode) {
        return /^\d{5}(?:[-\s]\d{4})?$/.test(zipCode);
    },
    validateCompanyDomain: function (email) {
        if (email &&
            (email.includes(".".concat(process.env.REACT_APP_CLIENT_DOMAIN_EMAIL)) || email.includes('.'))) {
            var trimmedEmail = email.replace(/\..*$/, '');
            return trimmedEmail;
        }
        return email;
    },
    verifyRoles: function (roles1, roles2) {
        var r1 = roles1.map(function (str) { return str.toLowerCase(); });
        var r2 = roles2.map(function (str) { return str.toLowerCase(); });
        return r1.some(function (role) {
            return r2.includes(role);
        });
    },
    routeBuilder: function (source, host) {
        var protocol = window.location.protocol;
        source = source.sourceId || source;
        if (Object.prototype.hasOwnProperty.call(exports.sourceToUrlMap, source)) {
            source = exports.sourceToUrlMap[source];
        }
        else if (source === 'company') {
            source = '';
        }
        return "".concat(protocol, "//").concat(source).concat(source ? '.' : '').concat(host);
    },
    getCookieValue: function (a) {
        var b = document.cookie.match("(^|;)\\s*".concat(a, "\\s*=\\s*([^;]+)"));
        return b ? b.pop() : '';
    },
    createCalendly: function () {
        var script = document.createElement('script');
        script.src = "".concat(process.env.REACT_APP_CALENDLY_CDN);
        script.async = true;
        document.body.appendChild(script);
    },
    getProductAppointments: function (appointments, productId) {
        var activeAppointment;
        var elapsedAppointment;
        var productAppointments = appointments.filter(function (appointment) {
            return appointment.productId === productId;
        });
        productAppointments.forEach(function (appointment) {
            var browserDate = Date.now();
            var appointmentTime = appointment.appointmentTime;
            if (appointmentTime && browserDate < appointmentTime) {
                activeAppointment = appointment;
            }
            else {
                elapsedAppointment = appointment;
            }
        });
        return { activeAppointment: activeAppointment, elapsedAppointment: elapsedAppointment };
    },
    validateMonth: function (month, year) {
        var date = new Date();
        // december selection of any year will be valid as next year we are not showing
        if (!(date.getMonth() === 11 && month === '12')) {
            if (date.getMonth() + 1 < parseInt(month, 10) && year === date.getFullYear()) {
                return false;
            }
        }
        return true;
    },
    isObject: function (value) { return value && typeof value === 'object' && value.constructor === Object; },
    removeNullKeys: function (obj) {
        return Object.keys(obj).reduce(function (result, k) {
            var _a, _b;
            if (obj[k] === null) {
                return result;
            }
            if (exports.companyHelpers.isObject(obj[k]) && Object.keys(obj[k]).length) {
                return __assign(__assign({}, result), (_a = {}, _a[k] = exports.companyHelpers.removeNullKeys(obj[k]), _a));
            }
            return __assign(__assign({}, result), (_b = {}, _b[k] = obj[k], _b));
        }, {});
    },
    sortByTextProperty: function (a, b) {
        var textA = a.text.toUpperCase();
        var textB = b.text.toUpperCase();
        var comparison = 0;
        if (textA > textB) {
            comparison = 1;
        }
        else if (textA < textB) {
            comparison = -1;
        }
        return comparison;
    },
    parseUserProducts: function (products) {
        return products
            .substring(2, products.length - 2)
            .replace(/=/g, ': ')
            .split('}, {')
            .map(function (p) {
            return p.split(', ').reduce(function (obj, str) {
                var _a;
                var _b = str.split(': '), key = _b[0], value = _b[1];
                return __assign(__assign({}, obj), (_a = {}, _a[key] = value, _a));
            }, {});
        });
    },
    formatTileName: function (name) {
        if (name) {
            return name.split(' ').join('-').toLowerCase();
        }
        return '';
    },
    getUnique: function (arr, key) {
        return arr
            .map(function (e) { return e[key]; })
            // store the keys of the unique objects
            .map(function (e, i, final) { return final.indexOf(e) === i && i; })
            // eliminate the dead keys & store unique objects
            .filter(function (e) { return arr[e]; })
            .map(function (e) { return arr[e]; });
    },
    getValidHTTPUrl: function (url) {
        if (url === void 0) { url = ''; }
        var newUrl = window.decodeURIComponent(url);
        newUrl = newUrl.trim().replace(/\s/g, '');
        if (/^(:\/\/)/.test(newUrl)) {
            return "http".concat(newUrl);
        }
        if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
            return "http://".concat(newUrl);
        }
        return newUrl;
    },
    sleep: function (ms) {
        return new Promise(function (resolve) { return setTimeout(resolve, ms); });
    },
    getValueFromString: function (inputString, key) {
        if (inputString.indexOf("".concat(key, "=")) < 0) {
            return null;
        }
        var stringAfterKey = inputString.substring(inputString.indexOf("".concat(key, "=")) + "".concat(key, "=").length);
        return stringAfterKey.substring(0, stringAfterKey.indexOf('&') > -1 ? stringAfterKey.indexOf('&') : stringAfterKey.length);
    },
    safeParse: function (string, defaultVal) {
        try {
            return JSON.parse(string);
        }
        catch (err) {
            return string || defaultVal;
        }
    }
};
//* Dashboard helper functions - userful for Tiles, Dashboard itself, or high level components
exports.platformHelpers = {
    formatPublishTileEventInput: function (_a, _b, payload, type, eventId, requestId) {
        var componentTypes = _a.componentTypes, eventType = _a.eventType, stateCurrent = _a.stateCurrent, statePrevious = _a.statePrevious, topic = _a.topic;
        var user = _b.user, account = _b.account, tile = _b.tile;
        if (type === void 0) { type = 'fetch'; }
        if (eventId === void 0) { eventId = (0, uuid_1.v4)(); }
        return {
            topic: topic || type,
            message: {
                payload: payload ? (0, json_stringify_safe_1["default"])(payload) : null,
                context: (0, json_stringify_safe_1["default"])({
                    user: user,
                    account: account,
                    product: tile.product,
                    tile: tile,
                    componentTypes: componentTypes
                }),
                metadata: (0, json_stringify_safe_1["default"])({
                    eventType: eventType,
                    tileId: tile.tileId,
                    stateCurrent: eventType === 'activate' ? 'active' : stateCurrent || tile.stateCurrent,
                    statePrevious: eventType === 'activate' ? 'inactive' : statePrevious || tile.stateCurrent,
                    isHidden: null,
                    seqNo: null
                })
            },
            attributes: {
                emitter: 'tile',
                eventId: eventId,
                triggerEventId: eventId,
                entity: 'product',
                entityId: tile.productId,
                status: 'trigger',
                operation: 'R',
                eventType: type,
                requestId: requestId
            }
        };
    },
    fetchOrderSummary: function (user, orderId, eventId, productId) {
        // refactor these method to make it generic
        return {
            topic: 'fetch',
            message: {
                payload: (0, json_stringify_safe_1["default"])({
                    orderId: orderId
                }),
                context: (0, json_stringify_safe_1["default"])({
                    user: user,
                    account: user.account
                }),
                metadata: (0, json_stringify_safe_1["default"])({
                    eventType: 'getOrderDataForPayment'
                })
            },
            attributes: {
                emitter: 'dashboard-payment',
                eventId: eventId,
                triggerEventId: eventId,
                entity: 'product',
                entityId: productId,
                status: 'trigger',
                operation: 'R'
            }
        };
    },
    publishPaymentEvent: function (paymentInfo, user, eventId, productId) {
        return {
            topic: 'transition',
            message: {
                payload: (0, json_stringify_safe_1["default"])(paymentInfo),
                context: (0, json_stringify_safe_1["default"])({
                    user: user,
                    account: user.account
                }),
                metadata: (0, json_stringify_safe_1["default"])({
                    eventType: 'activate',
                    stateCurrent: 'active',
                    statePrevious: 'buy',
                    tileId: 'c2f9c2e3-d5c1-4e0c-be09-6b394157bf44',
                    isHidden: null,
                    seqNo: null
                })
            },
            attributes: {
                emitter: 'dashboard-payment',
                eventId: eventId,
                triggerEventId: eventId,
                entity: 'product',
                entityId: productId,
                status: 'trigger',
                operation: 'R'
            }
        };
    },
    // eslint-disable-next-line
    urlInterpolate: function (url, userGraph) {
        // URL Formatting:
        // Gets an array of the variable values in the url, formatted just like template literals
        // Note: These values MUST exist on the user graph
        var matchedVars = url.match(/(\$.*?\})/g);
        // Map the array of variables to their corresponding user graph values
        var urlParamMap = matchedVars
            ? matchedVars.map(function (urlProp) {
                // eslint-disable-next-line
                var value = eval("userGraph.".concat(urlProp.replace('${', '').replace('}', '')));
                return { param: urlProp, value: value };
            })
            : [];
        // Map through proper values and replace the variables in the string with them
        urlParamMap.forEach(function (item) {
            url = url.replace(item.param, item.value);
        });
        return url;
    },
    centerNewWindow: function (url, title, w, h) {
        // eslint-disable-next-line
        var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
        var width = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
        var height = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
        var systemZoom = width / window.screen.availWidth;
        var left = (width - w) / 2 / systemZoom + dualScreenLeft;
        var top = (height - h) / 2 / systemZoom + dualScreenTop;
        window.open(url, title, "scrollbars=yes, width=".concat(w / systemZoom, ", height=").concat(h / systemZoom, ", top=").concat(top, ", left=").concat(left));
    },
    mapEventDataToComponent: function (notifications, type) {
        if (type === 'TileCarousel' || type === 'TileAppointmentScheduler') {
            return notifications;
        }
        return (0, get_1["default"])(notifications
            .filter(function (_a) {
            var body = _a.body;
            return body && body.componentTypes && body.componentTypes.includes(type);
        })
            //@ts-ignore
            .sort(function (_a, _b) {
            var a = _a.dateCreated;
            var b = _b.dateCreated;
            return b - a;
        }), 0);
    },
    removeAllNullKeys: function (obj) {
        var isObject = function (value) {
            return value && typeof value === 'object' && value.constructor === Object;
        };
        return Object.keys(obj).reduce(function (result, k) {
            var _a, _b;
            if (obj[k] === null) {
                return result;
            }
            if (isObject(obj[k]) && Object.keys(obj[k]).length) {
                return __assign(__assign({}, result), (_a = {}, _a[k] = exports.platformHelpers.removeAllNullKeys(obj[k]), _a));
            }
            return __assign(__assign({}, result), (_b = {}, _b[k] = obj[k], _b));
        }, {});
    },
    filterChildUserGroups: function (groups, userGraph) {
        // should eventually deprecate default filter but you'd need to fill in roles on SourceGroups for all sources
        var defaultFilter = function (group) {
            return userGraph.role === 'user'
                ? group.groupId !== 'e4f895c8-6731-4ad4-bf67-6d8fd47d98de' &&
                    group.groupId !== '450b18a0-6933-4fff-9f69-b598b6223eff' &&
                    group.groupId !== '1728b8c3-b398-46fb-ad9c-1240f6115e9a'
                : true;
        };
        var groupRoleFilter = function (group) {
            return exports.companyHelpers.verifyRoles(group.roles, [userGraph.role]);
        };
        return groups.filter(function (group) {
            return group.roles && userGraph.role ? groupRoleFilter(group) : defaultFilter(group);
        });
    },
    filterChildUserNavLinks: function (links, role) {
        if (role === 'user') {
            return links === null || links === void 0 ? void 0 : links.filter(function (link) { return (link === null || link === void 0 ? void 0 : link.label) !== 'Account Information' && (link === null || link === void 0 ? void 0 : link.label) !== 'Subscriptions'; });
        }
        return links;
    },
    capitalizeFirstLetter: function (value) {
        return value[0].toUpperCase() + value.slice(1);
    },
    formatPhoneNumber: function (str) {
        // Filter only numbers from the input
        var cleaned = "".concat(str).replace(/\D/g, '');
        // Check if the input is of correct
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            // Remove the matched extension code
            // Change this to format for any country code.
            var intlCode = match[1] ? '+1 ' : '';
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        }
        return null;
    },
    getRedirectURL: function (source, existingURL) {
        var newReturnUrl = existingURL;
        var newSource = source;
        var originArray = existingURL.split('//');
        var urlSplit = originArray[1].split('.');
        if (urlSplit[0].indexOf('dashboard') !== 0 && urlSplit[0].indexOf('localhost') !== 0) {
            urlSplit.shift();
        }
        //  TODO: The below mapping of source to URL is temp and
        // should go to Database table source, sourceConfig or sourceURI
        switch (newSource) {
            case 'ipayment':
                newSource = 'paysafe';
                break;
            case 'priority2':
                newSource = 'merchantprotectionplus';
                break;
            case 'priority3':
                newSource = 'bizdash';
                break;
            default:
        }
        newReturnUrl = "".concat(originArray[0], "//").concat(newSource !== 'company' ? "".concat(newSource, ".") : '').concat(urlSplit.join('.'));
        return newReturnUrl;
    },
    legalIncPaymentRedirect: function (urlParams, auth0, navigate) {
        var planId = urlParams.get('planId') || urlParams.get('planid');
        var productid = urlParams.get('productid');
        var orderid = urlParams.get('orderid');
        var referrer = urlParams.get('referrer');
        if (productid && productid === process.env.REACT_APP_LEGALINC_PRODUCTID) {
            navigate('/payment', {
                replace: true,
                state: {
                    userId: auth0.user && auth0.user.userId,
                    email: auth0.user && auth0.user.email,
                    productid: productid,
                    planId: planId,
                    orderid: orderid,
                    referrer: referrer
                }
            });
            return true;
        }
        return false;
    },
    formatNumWithCommas: function (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getComponentParamValue: function (params, key, eventData) {
        var tuple = (params || []).find(function (param) { return param.key === key; });
        if (eventData && tuple) {
            return (0, get_1["default"])(eventData, tuple.value);
        }
        return tuple ? tuple.value : undefined;
    },
    componentIsFetchingData: function (tileEvents, notifications, type) {
        var fetching = false;
        if (!(0, lodash_1.isEmpty)(tileEvents) &&
            (0, lodash_1.isEmpty)(notifications) &&
            tileEvents.some(function (event) { return event.componentTypes.includes(type); })) {
            fetching = true;
        }
        return fetching;
    },
    formatPhoneNumberToUS: function (number) {
        // todo: once the backend supports international phone number, we need to remove every instance of this helper being used
        if (number) {
            return (number === null || number === void 0 ? void 0 : number[0]) === '1' ? number.slice(1, number.length) : number;
        }
        return undefined;
    },
    formatPhoneNumberToI18n: function (number) {
        // todo: once the backend supports international phone number, we need to remove every instance of this helper being used
        if (number) {
            return (number === null || number === void 0 ? void 0 : number[0]) === '1' ? number : "1".concat(number);
        }
        return undefined;
    },
    getDifferenceBetweenDates: function (date1, date2) {
        return (Date.parse(date1) - Date.parse(date2)) / (1000 * 3600 * 24);
    },
    getFriendlyDate: function (date) {
        var _date = new Date(date);
        var yyyy = _date.getFullYear();
        var dd = _date.getDate();
        var mm = _date.getMonth() + 1;
        // @ts-ignore
        if (dd < 10)
            dd = "0".concat(dd);
        // @ts-ignore
        if (mm < 10)
            mm = "0".concat(mm);
        return "".concat(mm, "/").concat(dd, "/").concat(yyyy);
    },
    addDaysToDate: function (days, date) {
        date.setDate(date.getDate() + days);
        return date;
    }
};
// GraphQL - Utils
exports.graphQL = {
    fixNull: function (val) {
        if (!val || val === '') {
            return null;
        }
        return "\"".concat(val, "\"");
    }
};
var checkUserCreatedMarketo = function (authObj) { return __awaiter(void 0, void 0, void 0, function () {
    var currentUserGetCount, maxUserGetTries, userGetInterval, userId, email, userRefreshIntervalId;
    return __generator(this, function (_a) {
        currentUserGetCount = 0;
        maxUserGetTries = 3;
        userGetInterval = 5000;
        userId = authObj.userId, email = authObj.email;
        userRefreshIntervalId = setInterval(function () { return __awaiter(void 0, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (currentUserGetCount > maxUserGetTries) {
                            console.log('ERROR: Not able to get user data even after multiple tries');
                            clearInterval(userRefreshIntervalId);
                        }
                        return [4 /*yield*/, authObj.getUser(userId)];
                    case 1:
                        user = _a.sent();
                        if (user.marketoPersonId) {
                            clearInterval(userRefreshIntervalId);
                            authObj.auth.sendUserAcquisitionDataToMarketo(userId, email, authObj.auth.acquisitionProduct);
                        }
                        currentUserGetCount += 1;
                        return [2 /*return*/];
                }
            });
        }); }, userGetInterval);
        return [2 /*return*/];
    });
}); };
exports.checkUserCreatedMarketo = checkUserCreatedMarketo;
var plainStrToJson = function (str) {
    var jsonObj = {};
    str.split(';').forEach(function (ele) {
        if (ele) {
            var keyVal = ele.split(':');
            jsonObj[keyVal[0]] = keyVal[1];
        }
    });
    return jsonObj;
};
exports.plainStrToJson = plainStrToJson;
/**
 * Retries the given function until it succeeds given a number of retries and an interval between them. They are set
 * by default to retry 5 times with 1sec in between. There's also a flag to make the cooldown time exponential
 * @param {Function} fn - Returns a promise
 * @param {Number} retriesLeft - Number of retries. If -1 will keep retrying
 * @param {Number} interval - Millis between retries. If exponential set to true will be doubled each retry
 * @param {Boolean} exponential - Flag for exponential back-off mode
 * @return {Promise<*>}
 */
function retry(fn, retriesLeft, interval, exponential) {
    if (retriesLeft === void 0) { retriesLeft = 3; }
    if (interval === void 0) { interval = 1000; }
    if (exponential === void 0) { exponential = false; }
    return __awaiter(this, void 0, void 0, function () {
        var val, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 5]);
                    return [4 /*yield*/, fn()];
                case 1:
                    val = _a.sent();
                    return [2 /*return*/, val];
                case 2:
                    error_1 = _a.sent();
                    if (!retriesLeft) return [3 /*break*/, 4];
                    return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, interval); })];
                case 3:
                    _a.sent();
                    return [2 /*return*/, retry(fn, retriesLeft - 1, exponential ? interval * 2 : interval, exponential)];
                case 4: throw new Error("Max retries reached for function ".concat(fn.name));
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.retry = retry;
